import { AddonAction } from 'models/AddonAction';
import { TradeWay } from 'models/TradeWay';
import { useSelector } from 'react-redux';
import { getSidePanelAddonActionOrDefault, getSidePanelTradeWayOrDefault } from 'state/selectors';
import { AppState } from 'state/state.model';
import { WorkspaceType } from 'state/workspaces/model';

export const useClassNameFromTradeWay = (tabId: string, workspaceType: WorkspaceType) => {
  const way = useSelector((state: AppState) => getSidePanelTradeWayOrDefault(state, tabId));
  const addonAction = useSelector((state: AppState) => getSidePanelAddonActionOrDefault(state, tabId, workspaceType));
  const adjustedWay = adjustedWayByAddonAction(way, addonAction);

  return `sg-price ${adjustedWay.toLowerCase()}`;
};

export function adjustedWayByAddonAction(way: TradeWay, addonAction: AddonAction) {
  return addonAction === 'Decrease' ? swapWay(way) : way;
}

function swapWay(tradeWay: TradeWay) {
  return tradeWay === 'Buy' ? 'Sell' : 'Buy';
}
